// src/hooks/useViewState.ts
import { useState } from 'react';

// Import the ViewType enum from the ViewToggle component
// We'll need to refactor this later to avoid circular dependencies
import { ViewType } from '../components/views/ViewToggle';

/**
 * Custom hook to manage view state (board, table, calendar)
 * 
 * @returns Object containing view state and functions to manipulate it
 */
export const useViewState = () => {
  // View toggle state
  const [currentView, setCurrentView] = useState<ViewType>(ViewType.BOARD);

  /**
   * Change the current view
   * @param view The new view to display
   */
  const changeView = (view: ViewType) => {
    setCurrentView(view);
  };

  /**
   * Check if the current view is a calendar view (month or week)
   * @returns boolean indicating if the current view is a calendar view
   */
  const isCalendarView = () => {
    return currentView === ViewType.MONTH_VIEW || currentView === ViewType.WEEK_VIEW;
  };

  /**
   * Check if the current view is the board view
   * @returns boolean indicating if the current view is the board view
   */
  const isBoardView = () => {
    return currentView === ViewType.BOARD;
  };

  /**
   * Check if the current view is the table view
   * @returns boolean indicating if the current view is the table view
   */
  const isTableView = () => {
    return currentView === ViewType.TABLE;
  };

  return {
    currentView,
    changeView,
    isCalendarView,
    isBoardView,
    isTableView,
  };
};